import { apiConfig } from '@base/configs'
import i18n from '@base/i18n'

export const customerApiUrl = `${apiConfig.baseURL}/customer`

export const THIS_DAY = 0
export const THIS_MONTH = 1
export const LAST_MONTH = 2
export const THIS_YEAR = 3
export const LAST_YEAR = 4

export const SALES_SUMMARY_PERIODS = [
  {
    code: THIS_DAY,
    name: i18n.t(`multiselect.single_label.sales.${THIS_DAY}`),
  },
  {
    code: THIS_MONTH,
    name: i18n.t(`multiselect.single_label.sales.${THIS_MONTH}`),
  },
  {
    code: LAST_MONTH,
    name: i18n.t(`multiselect.single_label.sales.${LAST_MONTH}`),
  },
  {
    code: THIS_YEAR,
    name: i18n.t(`multiselect.single_label.sales.${THIS_YEAR}`),
  },
  {
    code: LAST_YEAR,
    name: i18n.t(`multiselect.single_label.sales.${LAST_YEAR}`),
  },
]